/**
 * Deep links (App Links no Android, Universal Links no iOS).
 *
 * Sem isso, o e-mail de recuperacao de senha abre no navegador, fora do app —
 * a usuaria redefine a senha num lugar e volta pro app em outro.
 *
 * A verificacao do dominio depende de dois arquivos servidos por
 * metria.demiplie.com.br:
 *   /.well-known/assetlinks.json            (Android)
 *   /.well-known/apple-app-site-association (iOS)
 */

import { getPlugin } from './native';

const HOSTS = ['metria.demiplie.com.br'];

// Trava de uma vez so — ver instalar().
let launchUrlConsumida = false;

/**
 * Converte a URL recebida em caminho interno do router.
 * Devolve null quando a URL nao e nossa ou aponta para a raiz (nada a fazer).
 */
export function caminhoDeUrl(url) {
  try {
    const u = new URL(url);
    if (!HOSTS.includes(u.hostname)) return null;
    const caminho = u.pathname + u.search + u.hash;
    return caminho && caminho !== '/' ? caminho : null;
  } catch {
    return null;
  }
}

/**
 * Instala o ouvinte de abertura por link. Recebe navegar(caminho).
 * Devolve uma funcao de limpeza. No-op na web.
 */
export function instalar(navegar) {
  const App = getPlugin('App');
  if (!App) return () => {};

  const handle = App.addListener('appUrlOpen', (evento) => {
    const caminho = caminhoDeUrl(evento && evento.url);
    if (caminho) navegar(caminho);
  });

  // App aberto por link com o processo morto: o evento pode ter ocorrido antes
  // do ouvinte existir, entao consultamos a URL de lancamento.
  //
  // UMA VEZ SO por execucao: getLaunchUrl() devolve a URL de abertura sempre
  // que consultada, nao apenas no cold start. Sem esta trava, toda remontagem
  // do App re-navegava para a URL original — a usuaria abre pelo link de
  // recuperacao de senha, vai para outra tela, e e puxada de volta.
  if (!launchUrlConsumida && typeof App.getLaunchUrl === 'function') {
    launchUrlConsumida = true;
    App.getLaunchUrl()
      .then((r) => {
        const caminho = caminhoDeUrl(r && r.url);
        if (caminho) navegar(caminho);
      })
      .catch(() => {});
  }

  return () => { Promise.resolve(handle).then(h => h && h.remove && h.remove()).catch(() => {}); };
}
